var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlaneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79725 1.78778C3.57833 1.25888 2.37693 2.56887 3.00741 3.73874L5.43473 8.25013C5.58884 8.54085 5.87606 8.73349 6.2018 8.77552L12.3664 9.5461C12.4855 9.56011 12.5766 9.66169 12.5766 9.78078C12.5766 9.89987 12.4855 10.0014 12.3664 10.0155L6.2018 10.786C5.87606 10.8281 5.58884 11.0242 5.43473 11.3114L3.00741 15.8228C2.37693 16.9927 3.57833 18.3027 4.79725 17.7738L20.2754 11.0662C21.3997 10.5794 21.3997 8.98218 20.2754 8.49531L4.79725 1.78778Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneIcon);
export default __webpack_public_path__ + "static/media/paper-plane-icon.f756fd35abaefdeeb23cde73cb7ec857.svg";
export { ForwardRef as ReactComponent };